module.exports = __webpack_public_path__ + "img/9922759.png";